import { del, get, patch, put } from "helpers/api_helper";

export const apiGetNotices = (params) => {
  return get("record/notices/", { params });
};

export const apiGetNotice = (id) => {
  return get(`record/notices/${id}`);
};

export const apiCreateNotice = (params) => {
  return put("record/notices/", params);
};

export const apiUpdateNotice = ({ id, ...params }) => {
  return patch(`record/notices/${id}`, params);
};

export const apiDeleteNotice = (id) => {
  return del(`record/notices/${id}`);
};

export const apiUpdateStatusNotices = (params) => {
  return patch("record/notices/update-status", params);
};
